export default "__VITE_ASSET__Ba_dTnRz__"